/* app/js/src/components/graphics/edit/fields/text.component.scss */
.cursor-pointer {
  cursor: pointer;
}
textarea {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border-radius: 4px;
  background-color: #ffffff;
  height: 30px;
  border: 1px solid #e1e6eb;
  line-height: 2.2em;
  font-size: 0.9em;
  padding: 0 15px;
  color: #232f3a;
}
textarea:focus {
  border: 1px solid #aee5ff;
  outline: none;
}
textarea::-webkit-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
textarea:-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
textarea::-moz-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
textarea:-ms-input-placeholder {
  font-weight: 200;
  color: #c9cdd6;
  font-size: 1em;
  letter-spacing: 0.1px;
}
textarea.ng-invalid.ng-dirty,
textarea.ng-invalid.ng-touched {
  border-color: #ef5350;
}
* {
  box-sizing: border-box;
}
.input-container,
.controls-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
textarea {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin-left: 7px;
  margin-right: 14px;
  height: 60px;
}
.text-controls-header {
  margin-top: 16px;
  margin-left: 7px;
  background-color: #e1e6eb;
  padding: 9px;
}
.control {
  margin-top: 24px;
}
.toggle-controls-btn {
  width: 32px;
  height: 30px;
  background: #ffffff;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}
.toggle-controls-btn ::ng-deep svg {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  fill: #879baf !important;
}
.toggle-controls-btn.active {
  border: 1px #e1e6eb solid;
}
.toggle-controls-btn:hover ::ng-deep svg,
.toggle-controls-btn.active ::ng-deep svg {
  fill: #a65bfa !important;
}
.toggle-controls-btn:hover ::ng-deep svg path,
.toggle-controls-btn.active ::ng-deep svg path {
  stroke: #a65bfa !important;
}
/*# sourceMappingURL=text.component.css.map */
